import Panel, { PanelBody, PanelHeader } from '../../../components/Panel'
import Button from '../../../components/Button'
import { PageHeader } from '../../../components/PagesUtilities'
import Initial from '../../../components/Initial'
import TableDiscountFactor from './TableDiscountFactor'
import { useHistory } from 'react-router'
import useInitial from '../useInitial'
import { storagePage } from '../storage'

export default function DiscountFactor() {
    const { push } = useHistory()
    const pageState = useInitial()

    return (
        <Initial pageState={pageState}>
            <div className="container_page--form">
                <Panel mode="form">
                    <PanelHeader title="Factores de precio y porcentajes de descuento" />
                    <PanelBody>
                        {storagePage.subcategoryValues.map(subcategoryValue => (
                            <TableDiscountFactor
                                subcategoryValue={subcategoryValue}
                                key={subcategoryValue.id}
                            />
                        ))}
                    </PanelBody>
                </Panel>
            </div>
            <PageHeader subtitle="(*) Complete todos los campos de factor y descuento de cada compañía">
                <Button
                    color="accent"
                    onClick={() => push('/configuration/subcategories')}
                >
                    Volver
                </Button>
            </PageHeader>
        </Initial>
    )
}
